import React from 'react';
import { GraduationCap, Calendar, BookOpen } from 'lucide-react';

const BulletinHeader = ({ etablissement, anneeAcademique, semestre }) => {
  return (
    <div className="bulletin-header bg-gradient-to-r from-[#202654] to-[#2a2f6c] text-white p-6">
      <div className="flex items-center justify-between">
        {/* Logo et nom établissement */}
        <div className="flex items-center space-x-4">
          <div className="bg-white/10 p-3 rounded-full">
            <GraduationCap className="h-8 w-8 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">
              {etablissement?.libelle || 'ÉTABLISSEMENT SCOLAIRE'}
            </h1>
            <p className="text-blue-100 text-sm">
              {etablissement?.adresse || 'Adresse de l\'établissement'}
            </p>
          </div>
        </div>

        {/* Informations période */}
        <div className="text-right">
          <div className="flex items-center justify-end space-x-2 mb-2">
            <Calendar className="h-5 w-5" />
            <span className="text-lg font-semibold">
              Année : {anneeAcademique?.libelle || '2023-2024'}
            </span>
          </div>
          <div className="flex items-center justify-end space-x-2">
            <BookOpen className="h-5 w-5" />
            <span className="text-lg font-semibold">
              {semestre ? `Semestre ${semestre.numero}` : 'Semestre 1'}
            </span>
          </div>
        </div>
      </div>

      {/* Titre du document */}
      <div className="text-center mt-6 py-4 border-t border-white/20">
        <h2 className="text-3xl font-bold tracking-wide">
          RELEVÉ DE NOTES
        </h2>
        <p className="text-blue-100 mt-2">
          Bulletin semestriel de l'étudiant
        </p>
      </div>
    </div>
  );
};

export default BulletinHeader;
